// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width: 750px) {\nhtml {\n    font-size: 3.12267rem !important;\n}\nbody {\n    max-width: 13.33333rem;\n    margin: 0 auto;\n}\n}", ""]);
// Exports
module.exports = exports;
